import axios from 'axios'

import { readRefusal } from './readRefusal'

const NOT_FOUND_STATUS = 404

/**
 * Whether the API answered with its generic not-found, meaning the form is gone.
 *
 * A 404 carrying a `code` is a named refusal and is not treated as this.
 */
export const isFormGone = (error: unknown): boolean =>
  readRefusal(error) === null &&
  axios.isAxiosError(error) &&
  error.response?.status === NOT_FOUND_STATUS
